import { Utils } from "../../../util";

enum NotificationActionType {
  Close = 'close',
  View = 'view',
}

class NotificationAction {
  public readonly Id: string = Utils.GetGuid();
  public readonly Label: string;
  public readonly Callback: () => void;
  public readonly Type: NotificationActionType;

  constructor(type: NotificationActionType, label: string, callback: () => void) {
    this.Label = label;
    this.Type = type;
    this.Callback = callback;
  }
}

export { NotificationAction, NotificationActionType }
